





































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import { default as CommentEditor, instanceOfICommentEditor } from "../editors/controls/CommentEditor.vue";
import { IReferenceCommentListTableCondition } from "../lists/tables/IReferenceCommentListTableCondition";
import { ICommentDialogCondition } from "./ICommentDialogCondition";

@Component({
  components: {
    CommentEditor,
  }
})
export default class CommentDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      isConfirmed: false,
      title: "",
      note: "",
      shouldEmphasizeInput: false,
      referenceCondition: null,
    };
  }
  isConfirmed: boolean;
  title: string;
  note: string;
  shouldEmphasizeInput: boolean;
  referenceCondition: IReferenceCommentListTableCondition;

  async show(condition: ICommentDialogCondition): Promise<CommentDialog> {
    return this.showModal(async () => {
      this.isConfirmed = false;
      this.title = condition.name;
      this.note = condition.note
        ? condition.note
        : "";
      this.shouldEmphasizeInput = !!condition.shouldEmphasizeInput;
      this.referenceCondition = condition.reference;
      await this.$nextTick();
      if (instanceOfICommentEditor(this.$refs.commentEditor)) {
        this.$refs.commentEditor.focus();
        this.$refs.commentEditor.setSelectionRange(this.note.length, this.note.length);
      }
      await this.waitHidden(true);
      this.referenceCondition = null;
      return this;
    });
  }

  async confirm(): Promise<void> {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }
}
